var React = require('react');

function MoreInline (props) {
    return React.createElement("polygon",props);
}

MoreInline.defaultProps = {"stroke":"none","fill":"currentColor","fillRule":"evenodd","points":"9.00349603 1 9.00349603 7.0085634 15 7.00919977 15 9.00645472 9.00349603 9.00645472 9.00349603 15 7.00808703 15 7.00808703 9.00645472 1 9.00645472 1 7.00919977 7.00808703 7.00919977 7.00808703 1"};

module.exports = MoreInline;

MoreInline.default = MoreInline;
